
window.addEventListener('load', function () {
  if(document.querySelector('main')){
    document.querySelector('main').classList.add('isready')
  }
  if (document.querySelectorAll('.tab__wrapper') != null) {
    document.querySelectorAll('.tab__wrapper').forEach(function (e) {
      e.addEventListener('click', function () {
        document.querySelector('.tab__content').classList.add('open--tab');
        let tab = e.getAttribute('id');
        document.querySelector('.' + tab).classList.add('view');
        if (document.querySelector('.' + tab + '--img') != null) {
          document.querySelector('.' + tab + '--img').classList.add('view');
        }
        document.body.classList.add('body--hidden')
      });
    });
    document.querySelectorAll('.tab__close').forEach(function (e) {
      e.addEventListener('click', function () {
        document.querySelector('.tab__content').classList.remove('open--tab');
        document.querySelector('.tab__inner.view').classList.remove('view');
        if (document.querySelector('.care-type__media.view') != null) {
          document.querySelector('.care-type__media.view').classList.remove('view');
        }
        document.body.classList.remove('body--hidden')
      });
    });
  }
  if (document.querySelector('.collection__main__menu') != null) {
    if (this.window.innerWidth > 681) {
      document.querySelector('.collection__main__menu').setAttribute('open', 'open');
    }
  }
  if(document.querySelector(".countdown__time") !=null){
    iniciarCuentaAtras();
  }
  /*  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    const isSmallScreen = window.innerWidth < 1350;

    if (isTouchDevice && isSmallScreen) {
        // Selecciona todos los elementos con la clase 'main__menu__item'
        const menuItems = document.querySelectorAll('.main__menu__item');
        menuItems.forEach(item => {
            item.onclick = () => {
                item.classList.toggle('open');
            };
        });
        const menuItems2 = document.querySelectorAll('.submenu__wrp');
        menuItems2.forEach(item => {
            item.onclick = () => {
                item.classList.toggle('open');
            };
        });
        const menuItems3 = document.querySelectorAll('.header__lang__item');
        menuItems3.forEach(item => {
            item.onclick = () => {
                item.classList.toggle('open');
            };
        });
    }

*/
	if (document.querySelector('.announcement-bar-section') != null) {
		document.body.classList.add('announcement-bar--on');
	}
  if(document.querySelector('.utility__bar') != null){
    let an = document.querySelector('.utility__bar').offsetHeight;
    document.documentElement.style.setProperty('--annoucement-height', `${an}px`)

  }

  addTocartSuggested()
  
});

window.addEventListener('resize', function () {
  if (document.querySelector('.collection__main__menu') != null) {
    if (this.window.innerWidth > 681) {
      document.querySelector('.collection__main__menu').setAttribute('open', 'open');
    } else {
      document.querySelector('.collection__main__menu').removeAttribute('open');
    }
  }
  if(document.querySelector('.utility__bar') !=null){
    let an = document.querySelector('.utility__bar').offsetHeight;
    document.documentElement.style.setProperty('--annoucement-height', `${an}px`)

  }
});

  function changemarket(market){
    console.log(market);
    let go=market.value.toLowerCase();
    let lg='en-'+go+'/';
    if(go=='es'){
      lg='';
    }
    /*if(go=='fr'){
      lg='fr-fr/';
    }*/
    window.location.href="https://mercstoreules.com/"+lg;
}

  /*function marketgo(){
    let parent = document.querySelector('.market__modal__container');
    let marketSelected = document.querySelector('#modal-country-selector').value.toLowerCase();
    let langSelected = document.querySelector('#LanguageSelector').value;
    let lg=langSelected+'-'+marketSelected+'/';
    if(marketSelected == 'es'){
      if(langSelected =='es'){
        lg = '';
      }else{
        lg = langSelected + '/';
      }
       
    }
    setCookie('market', true, 1);

    window.location.href="https://mercstoreules.com/"+lg;
}*/

function marketgo() {
  const marketSelected = document
    .querySelector('#modal-country-selector')
    .value.toLowerCase();

  const langSelected = document
    .querySelector('#LanguageSelector')
    .value.toLowerCase();

  let lg = `${langSelected}-${marketSelected}/`;

  if (marketSelected === 'es') {
    lg = langSelected === 'es' ? '' : `${langSelected}/`;
  }

  const url = new URL(window.location.href);

  // Prefijo actual: "", "/en", "/en-fr", etc.
  const currentRoot = window.Shopify.routes.root.replace(/\/$/, '');

  // Elimina únicamente el prefijo actual.
  let path = url.pathname;

  if (
    currentRoot &&
    (path === currentRoot || path.startsWith(`${currentRoot}/`))
  ) {
    path = path.slice(currentRoot.length);
  }

  // Añade el nuevo prefijo manteniendo la página actual.
  url.pathname = `/${lg}${path.replace(/^\/+/, '')}`;

  setCookie('market', true, 1);
  console.log('marketgo', url.href)
  window.location.href = url.href;
}


function formatPrice(priceInCents, currencyCode = 'EUR') {
  const language = document.documentElement.lang || 'en'; // Por defecto 'en'
  var price = (priceInCents / 100).toFixed(2);
  if (price.endsWith('.00') || price.endsWith(',00')) {
    price = price.replace('.00', '').replace(',00', ''); // Eliminar decimales si son 00
  }
  // Determinar el formato según el idioma
  if (language.startsWith('es') || language.startsWith('fr')) {
    // Formato para español
    return `${price.replace('.', ',')} ${currencyCode}`;
  } else {
    // Formato para inglés o cualquier otro idioma
    return `${currencyCode} ${price}`;
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function updateLocalization({ mark, language }) {
  console.log('marketmodal');
  const formId = crypto.randomUUID();
  if (getCookie('market')) return;
  //console.log('mercado', mark, language);
  //console.log('shopify', window.Shopify.country, window.Shopify.locale);
  let popup = document.querySelector('.market__modal');
  let market = nameMarket(mark);
  let market2 = nameMarket(window.Shopify.country);
  let lang = ( window.Shopify.locale == 'es')?  window.Shopify.locale : 'en';
  let footerSelect = document.querySelector('#footer-country-selector');
  console.log(mark, window.Shopify.country)
if(market[0].host == market2[0].host){
  return}
 if (mark != window.Shopify.country) {
  popup.classList.add('show');
  const select = popup.querySelector('#modal-country-selector');
  select.value = market[0].sel
    console.log('mercados no coinciden', 'market='+market[0].cod);
    
  }

  //window.location.href = '/en/';
}
function nameMarket(code) {
  let market;
  if (code == 'ES') {
    market = [{ es: 'España', en: 'Spain', fr: 'Espagne', url:'', mk :true, host: 'mercstoreules.com', lang:'es', cod:'ES', sel:'ES'}];
  //else if (code == 'MX') {
  //  market = [{ es: 'Mexico', en: 'Mexico', fr: 'Mexico', url:'mx', mk :true, host: 'mercules.mx', lang:'es', cod:'MX'}];
  } else if (code == 'UK' || code == 'GB') {
    market = [{ es: 'Reino Unido', en: 'United Kingdom', fr: 'Royaume-Uni' , url:'uk', mk :true, host: 'mercules.uk', lang:'en', cod:'UK', sel:'UK'}];
  /*} else if (code == 'FR') {
    market = [{ es: 'Francia', en: 'France', fr: 'France',url:'fr', mk :true , host: 'mercules.fr', code:'FR'}];*/
  } else if (code =='AL' || code =='AX' || code =='AT' || code =='AD' || code =='BE' || code =='BY' || code =='BA' || code =='BG' || code =='CZ' || code =='DK' || code =='EE' || code =='FI' || code =='FO'|| code =='FR'|| code =='DE' || code =='GG' || code =='GI' || code =='GR' || code =='HR' || code =='HU' || code =='IE' || code =='IM' || code =='IS' || code =='IT' || code =='JE' || code =='LI' || code =='LT' || code =='LU' || code =='LV' || code =='MC' || code =='ME' || code =='MD' || code =='MK' || code =='MT' || code =='NL' || code =='NO' || code =='PL' || code =='RO' || code =='RS' || code =='RU' || code =='SE' || code =='SI' || code =='SJ' || code =='SK' || code =='SM' || code =='UA' || code =='CH' || code =='VA' ) {
    market = [{ es: 'Resto de Europa', en: 'Rest of Europe', fr: 'Europe' , url:'eu', mk :true, host: 'mercules.eu', lang:'en', cod:'EU', sel:'EU'}];
  } else if (code == 'PT') {
    market = [{ es: 'Portugal', en: 'Portugal', fr: 'Portugal', url:'', mk :true, host: 'mercstoreules.com', lang:'es', cod:'PT', sel:'PT'}];  
  } else if (code == 'US') {
    market = [{ es: 'Estados Unidos', en: 'USA', fr: 'USA',url:'us', mk :false , host: 'mercules.us', code:'US',lang:'en', sel:'US'}];
  } else {
    market = [{ es: 'Resto del mundo', en: 'Rest of the world', fr: 'Reste du monde', url:'us', mk :false, host: 'mercules.us', lang:'en', cod:'US', sel:'US'}];
  }
  return market;
}

function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}
function getCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('.menu__drawer--wrp');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {

    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = document.body.classList.contains('menu--open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        document.body.classList.add('menu--open');
   

        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu--open');
        /* !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);*/
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      document.body.classList.add('menu--open');
        if (window.innerWidth < 1280 && 'ontouchstart' in window && document.body.classList.contains('page--top') && !document.body.classList.contains('page__home')) {
            
            let navbarHeight = document.querySelector('header').offsetHeight;
            document.querySelector('main').style.marginTop = navbarHeight + 'px';
        }
    });
    summaryElement.setAttribute('aria-expanded', true);
    //trapFocus(this.mainDetailsToggle, summaryElement);
    //document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    document.body.classList.remove('menu--open');
       if (window.innerWidth < 1280 && 'ontouchstart' in window && document.body.classList.contains('page--top') && !document.body.classList.contains('page__home')) {
            document.querySelector('main').style.marginTop = '0px';
        }
    /* this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      console.log('plplpl');
      details.removeAttribute('open');
      details.classList.remove('menu--open');
    });*/
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelectorAll('.submenu--open').forEach((submenu) => {
      submenu.classList.remove('submenu--open');
    });
    //document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    // removeTrapFocus(elementToFocus);
    // this.closeAnimation(this.mainDetailsToggle);

    //if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu--open');
    parentMenuElement && parentMenuElement.classList.remove('submenu--open');
    document.body.classList.remove('menu--open');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));

    //this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
super();
    this.mobileItem= this.querySelectorAll('.mobile__menu__item');
    this.mobileItem.forEach((button) => button.addEventListener('click', this.closeDetails.bind(this,button)));

  
  }
    closeDetails(button){

        if (button.hasAttribute('open')) {
            return
        }
        const parentLi = button.parentElement;
        const siblingLis = [...parentLi.parentElement.children];
  
        siblingLis.forEach(function(item){
            if(item.querySelector('details') !=null){
                item.querySelector('details').removeAttribute('open');
            }
        })
        
        setTimeout(function(){button.setAttribute('open', 'true')},10);

    }
  /*openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu--open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu--opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }*/

  /*closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu--open');
    window.removeEventListener('resize', this.onResize);
  }*/

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      //if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          if (document.querySelector('.glide-related') != null) {
            var glideProduct = new Glide('.glide-related', {
              type: 'slider',
              bound: true,
              startAt: 0,
              rewind: false,
              gap: 0,
              perView: 6,
              breakpoints: {
                2000: { perView: 5 },
                1500: { perView: 4 },
                980: { perView: 3 },
                680: { perView: 2 },
              },
              classes: {
                dragging: 'dragging',
              },
              animationTimingFunc: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
              animationDuration: 500,
            }).mount({ ArrowDisabler });

            checkslideperview('.related__product__slider');

            document
              .querySelector('.product__slider--related .arrow__left')
              .addEventListener('click', function (event) {
                event.preventDefault();

                glideProduct.go('<');
              });

            document
              .querySelector('.product__slider--related .arrow__right')
              .addEventListener('click', function (event) {
                event.preventDefault();

                glideProduct.go('>');
              });

            window.addEventListener('resize', function () {
              checkslideperview('.related__product__slider');
            });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

function checkslideperview(arg) {
  let slide = document.querySelector(arg);
  let related = slide.querySelector('.glide--number').value;

  let wv = window.innerWidth;
  if (
    (wv > 2000 && related <= 6) ||
    (wv > 1500 && related <= 5) ||
    (wv > 980 && related <= 4) ||
    (wv > 680 && related <= 2)
  ) {
    slide.classList.add('no--events');
  } else {
    slide.classList.remove('no--events');
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class cartRecommendations2 extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let items = document.querySelectorAll('#CartDrawer-Form .cart__item')
    let currency = window.Shopify.currency.active;
    let lang= document.querySelector('html').getAttribute('lang');
    const cartItems = document.querySelectorAll('#CartDrawer-Form .cart__item');

    const id1 = cartItems[0]?.getAttribute('data-id') ?? null;
    const id2 = cartItems[1]?.getAttribute('data-id') ?? id1;
    const comunUrl = this.dataset.url
    var dataUrl1;
    var dataUrl2;
    if(id1 !== id2){
    dataUrl1=comunUrl+id1+'&limit=1';
    dataUrl2=comunUrl+id2+'&limit=1';
    }else{
    dataUrl1=comunUrl+id1+'&limit=2';
    }

    var that = this;
      //if (!entries[0].isIntersecting) return;
      
       if(id1 === id2){
        console.log(1)
        fetch(dataUrl1)
          .then((response) => response.text())
          .then((text) => {
            
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.cart-recommendations-items');
            console.log(recommendations)
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

              const images = recommendations.querySelectorAll('img');

              const imagePromises = Array.from(images).map((img) => {
              if (img.complete) {
                  return Promise.resolve();
              }
              return new Promise((resolve, reject) => {
                  img.addEventListener('load', resolve);
                  img.addEventListener('error', reject);
                  });
              });

              Promise.all(imagePromises)
              .then(() => {
                  console.log('images.loaded')
                  //ScrollTrigger.refresh();
              })
              .catch((err) => {
                  //ScrollTrigger.refresh();
              });

          })
       }else{
        console.log(2)
        fetch(dataUrl1)
          .then((response) => response.text())
          .then((text) => {
            
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.cart-recommendations-items>div');
            if (recommendations && recommendations.innerHTML.trim().length) {
              that.append(recommendations);
            }

              const images = recommendations.querySelectorAll('img');

              const imagePromises = Array.from(images).map((img) => {
              if (img.complete) {
                  return Promise.resolve();
              }
              return new Promise((resolve, reject) => {
                  img.addEventListener('load', resolve);
                  img.addEventListener('error', reject);
                  });
              });

              Promise.all(imagePromises)
              .then(() => {
                  console.log('images.loaded')
                  //ScrollTrigger.refresh();
              })
              .catch((err) => {
                  //ScrollTrigger.refresh();
              });

          })
          fetch(dataUrl2)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations2 = html.querySelector('.cart-recommendations-items');
            if (recommendations2 && recommendations2.innerHTML.trim().length) {
              this.append(recommendations2.children[0]);
            }

              const images = recommendations2.querySelectorAll('img');

              const imagePromises = Array.from(images).map((img) => {
              if (img.complete) {
                  return Promise.resolve();
              }
              return new Promise((resolve, reject) => {
                  img.addEventListener('load', resolve);
                  img.addEventListener('error', reject);
                  });
              });

              Promise.all(imagePromises)
              .then(() => {
                  console.log('images.loaded')
                  //ScrollTrigger.refresh();
              })
              .catch((err) => {
                  //ScrollTrigger.refresh();
              });

          })         
       }
	
	


  }
}


customElements.define('cart-recommendations', cartRecommendations2);

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.header__icon--search').forEach(function (e) {
    e.addEventListener('click', function () {
      document.querySelector('.predictive-search--wrapper').classList.add('open--search');
      document.querySelector('.search__input').focus();
      setTimeout(function() {
		//window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
	  },10);
      document.body.classList.add('search--modal');
    });
  });
  document.querySelector('.predictive-search--close').addEventListener('click', function () {
    document.querySelector('.predictive-search--wrapper').classList.remove('open--search');
    document.body.classList.remove('search--modal');
  });
});


class fastadd extends HTMLElement {
  constructor() {
    super();
    var that = this;
    this.container = this.querySelector('.fast__add__container');
    if(this.container== null){
        
        this.container = this.querySelector('.fast__add__mobile');
        this.buttonMobile = this.querySelector('.button--mobile');
        this.buttonMobile.addEventListener('click', this.onMobileOpenProduct.bind(this));
    }else{
        
        this.button = this.container.querySelector('.button--fast');
        this.buttonMobile = this.querySelector('.mobile--fast');
        this.button.addEventListener('click', this.onButtonClick.bind(this));
        this.buttonMobile.addEventListener('click', this.onMobileOpen.bind(this));
    }
    
    this.variants = this.container.querySelectorAll('.swatch__input');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    /*this.variants.forEach(function (v) {
      v.addEventListener('change', that.onInputChange.bind(this));
    });*/
    this.variants.forEach(function (v) {
      v.addEventListener('click', that.onButtonClick.bind(that));
    });
  }

  onInputChange(event) {
    let par = event.target.closest('fast-add');
    let btn = par.querySelector('.button--fast');
    let btns = btn.querySelector('span');
    let txt = btns.getAttribute('data-t0');
    btn.classList.remove('disabled');
    btns.innerHTML = txt;
  }

  onMobileOpen(event) {
    this.container.classList.add('open-fast');
    let that=this;
    setTimeout(function(){that.container.classList.remove('open-fast')},4000)
  }

   onMobileOpenProduct(event) {
    let numvar = this.container.querySelectorAll('.swatch__input').length;
    console.log(numvar);
    if(numvar >1){
        this.container.classList.toggle('open--fast');
    }else{
       this.container.querySelector('.swatch__input').click();
    }
  }


  onButtonClick(event) {
    var tth = this;
    var par = event.target.closest('fast-add');
    let numvar = this.container.querySelectorAll('.swatch__input').length;

    var parId = par.getAttribute('id');
    var checkedInput = par.querySelector('.swatch__input:checked');
    var attrcheck = par.querySelector('.swatch__input').getAttribute('checked')
    if (checkedInput || attrcheck) {
      var id = (checkedInput)?checkedInput.value : par.querySelector('.swatch__input').value;
  
      if (id) {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData();
        this.querySelector('.loading__spinner').classList.remove('hidden');

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        formData.append('quantity', 1);
        formData.append('id', id);

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            let that = this;
            setTimeout(function () {
              that.querySelector('.loading__spinner').classList.add('hidden');
            }, 200);
            tth.container.classList.remove('open--fast');
            //this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            //if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            //this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
    }
  }
}
customElements.define('fast-add', fastadd);


class zoomproduct extends HTMLElement {
  constructor() {
   
    super();
    var that = this;
    this.scale=1;
    this.startDistance=0;
    this.translateX = 0;
    this.translateY = 0;
    this.startCenter = { x: 0, y: 0 };
    this.panStart = { x: 0, y: 0 };
    this.lastTouch = { x: 0, y: 0 };
    this.isDragging = false;
    this.container = this.querySelector('.product__media-gallery');
    this.leftButton = this.querySelector('.zoom__arrow--left');
    this.rightButton = this.querySelector('.zoom__arrow--right');
    this.closeButton = this.querySelector('.zoom--close');
    this.images = this.querySelectorAll('.product__media-item').forEach(function(el){
        el.addEventListener('touchstart', (e) => {
            if (isMobile()){
           
            }else{
            if (e.touches.length === 2) {
                that.startDistance = that.getDistance(e.touches);
                that.startCenter = that.getCenter(e.touches);
                that.lastScale = that.scale;
                that.isDragging = false;
            }else if (e.touches.length === 1) {
                that.lastTouchX = e.touches[0].clientX;
                that.lastTouchY = e.touches[0].clientY;
                that.isDragging = true;
            }
            }
        }, { passive: false });
    
    })
    this.images = this.querySelectorAll('.product__media-item')
    this.images.forEach(function(el){
        if (isMobile()){
            
        }else{
            el.addEventListener('touchmove', (e) => {
      
            if (e.touches.length === 1 && that.isDragging && that.scale > 1.5) {
                e.preventDefault();
                const touch = e.touches[0];
                const dx = touch.clientX - that.lastTouchX;
                const dy = touch.clientY - that.lastTouchY;
                that.translateX += dx;
                that.translateY += dy;
                that.lastTouchX = touch.clientX;
                that.lastTouchY = touch.clientY;
                that.updateTransform(el);
            }
                
            }, { passive: false })
        }
    })

    this.querySelectorAll('.product__media-item').forEach(function(el){
        el.addEventListener('touchend', (e) => {
        if (e.touches.length < 2) {
            that.startDistance = 0;
            that.isDragging = false;
            }
        }, { passive: false });
    })
    if(this.leftButton){
    this.leftButton.addEventListener('click', this.onLeftButtonClick.bind(this));
    }
    if(this.rightButton){
        this.rightButton.addEventListener('click', this.onRightButtonClick.bind(this));
    }
    this.closeButton.addEventListener('click', this.onCloseButtonClick.bind(this));
   document.querySelectorAll('.product__media--js img').forEach(function (e) {

        e.addEventListener('click', function(){

       document.querySelector('.page__product').classList.add('zoom--active');
       document.querySelector('.page__product').scrollLeft= document.querySelector('.page__product').scrollWidth/2;
        let id=e.parentNode.getAttribute('data-media-id');
        if(!id){
          if(document.querySelector('.product__image__wrp').classList.contains('media__track')){
          id=document.querySelector('.product__media--js .product__media-item').getAttribute('data-media-id');
          }else{
          id=document.querySelector('.product__media-item.glide__slide--active').getAttribute('data-media-id');
          }
        }

       let zoomEl = that.querySelector('.product__media-item[data-media-id="'+id+'"]');
       zoomEl.classList.add('active');
            if (isMobile()){
                window.zoomEl = new PinchZoom.default(zoomEl, {});
            }
        })
    })
    document.addEventListener('keydown', function(event) {
        if(document.querySelector('.page__product').classList.contains('zoom--active')){
            if (event.key === 'Escape') {
                that.closeButton.click();
            } else if (event.key === 'ArrowLeft') {
                that.leftButton.click();
            } else if (event.key === 'ArrowRight') {
                that.rightButton.click();
            }
        }
    });
        
    
  }
    getDistance(touches) {
     const dx = touches[1].clientX - touches[0].clientX;
      const dy = touches[1].clientY - touches[0].clientY;
      return Math.hypot(dx, dy);
    }
    updateTransform(img) {
        console.log('transX', this.translateX);
        const scaledWidth = img.offsetWidth * this.scale;
        const scaledHeight = img.offsetHeight * this.scale;
        const containerWidth = window.innerWidth;
        const containerHeight = window.innerHeight;

        const minX = Math.min((-scaledWidth + containerWidth), 0);
        const maxY = Math.max((scaledHeight - containerHeight) / 2, 0);
        
        this.translateX = Math.min(Math.max(this.translateX,minX),0)
        this.translateY = Math.min(Math.max(this.translateY, -maxY), maxY);
        
        img.style.transform = `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`;
    }

    getCenter(touches) {
      return {
        x: (touches[0].clientX + touches[1].clientX) / 2,
        y: (touches[0].clientY + touches[1].clientY) / 2
      };
    }
    
    onCloseButtonClick(event){
        if (isMobile()){
			window.zoomEl.destroy();
		}
        document.querySelector('.page__product').classList.remove('zoom--active');
        if(document.querySelector('zoom-product .product__media-item.active')){
        document.querySelector('zoom-product .product__media-item.active').classList.remove('active');
        }
    }
    onLeftButtonClick(event){
        if (isMobile()){
			window.zoomEl.destroy();
		}
       let pos =parseInt(document.querySelector('zoom-product .product__media-item.active').getAttribute('data-pos'));
       let total = parseInt(document.querySelectorAll('zoom-product .product__media-item').length);
       let next = (pos == 1)?total:pos-1;
       document.querySelector('zoom-product .product__media-item.active').classList.remove('active');
       let zoomEl = document.querySelector('zoom-product .product__media-item[data-pos="'+next+'"]')
       zoomEl.classList.add('active')
       if (isMobile()){
            window.zoomEl = new PinchZoom.default(zoomEl, {});
        }
    }
    onRightButtonClick(event){
		if (isMobile()){
			window.zoomEl.destroy();
		}
        let pos =parseInt(document.querySelector('zoom-product .product__media-item.active').getAttribute('data-pos'));
       let total = parseInt(document.querySelectorAll('zoom-product .product__media-item').length);
       let next = (pos == total)?1:pos+1;
       document.querySelector('zoom-product .product__media-item.active').classList.remove('active');
       let zoomEl = document.querySelector('zoom-product .product__media-item[data-pos="'+next+'"]');
       console.log(pos,next, zoomEl)
       zoomEl.classList.add('active')
       if (isMobile()){
            window.zoomEl = new PinchZoom.default(zoomEl, {});
        } 
    }

}
customElements.define('zoom-product', zoomproduct);

class RecentlyProducts extends HTMLElement {
  constructor() {
    super();
    this.cookieName = 'recently_viewed_products';
    this.maxItems = 6;
    this.container = this.querySelector('.glide__track')
  }

  connectedCallback() {
    this.loadProducts();
  }

  async loadProducts() {
    const cookie = getCookie(this.cookieName);
    var that = this;

    if (!cookie){
      that.style.display = 'none';
      return;
    }
    let handles;
    try {
      handles = JSON.parse(cookie);
    } catch (e) {
      console.warn('Cookie malformada:', e);
      return;
    }

    if (!Array.isArray(handles) || !handles.length) return;

    // limitar la cantidad de productos
    handles = handles.slice(0, this.maxItems);

    // Crear contenedor
    const container = document.createElement('div');
    container.classList.add('glide__slides');

    // Obtener cada producto por handle
    for (const handle of handles) {
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) continue;
        const product = await res.json();

        const productHTML = renderProductCard(product);
        container.insertAdjacentHTML('beforeend', productHTML);

      } catch (err) {
        console.warn(`Error cargando producto ${handle}`, err);
      }
    }

    // Render final solo si hay productos
    if (container.children.length > 0) {

      this.container.appendChild(container);
      this.style.display = 'block';
    
            var glideProduct = new Glide('.glide-viewed', {
              type: 'slider',
              bound: true,
              startAt: 0,
              rewind: false,
              gap: 0,
              perView: 6,
              breakpoints: {
                2000: { perView: 5 },
                1500: { perView: 4 },
                980: { perView: 3 },
                680: { perView: 2 },
              },
              classes: {
                dragging: 'dragging',
              },
              animationTimingFunc: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
              animationDuration: 500,
            }).mount({ ArrowDisabler });

            checkslideperview('.recently__product__slider');

            document
              .querySelector('.product__slider--recently .arrow__left')
              .addEventListener('click', function (event) {
                event.preventDefault();

                glideProduct.go('<');
              });

            document
              .querySelector('.product__slider--recently  .arrow__right')
              .addEventListener('click', function (event) {
                event.preventDefault();

                glideProduct.go('>');
              });

            window.addEventListener('resize', function () {
              checkslideperview('.recently__product__slider');
            });
          
    } else {
      that.style.display = 'none';
    }
  }
}

customElements.define('recently-products', RecentlyProducts);

class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let item = document.querySelector('#CartDrawer-Form .cart__item').getAttribute('data-id');
    let items = document.querySelectorAll('#CartDrawer-Form .cart__item')
    let that =  this;
    let currency = window.Shopify.currency.active;
    let lang= document.querySelector('html').getAttribute('lang');
    if(items.length == 1 && item){
		
      fetch(window.Shopify.routes.root + "recommendations/products.json?product_id="+item+"&limit=2&intent=related")
        .then((response) => response.json()) 
        .then(data => {
          var related=data.products;

          that.innerHTML ='';
        
            related.forEach(function(product){
                that.innerHTML += that.renderSuggestedProduct(product, true, currency, lang);

            })
          
        })
        .catch((e) => {
          console.error(e);
        });
    }
    if(items.length >= 2){
      const id1 = document.querySelectorAll('#CartDrawer-Form .cart__item')[0].getAttribute("data-id");
      const id2 =  document.querySelectorAll('#CartDrawer-Form .cart__item')[1].getAttribute("data-id");
      that.loadRecommendations(id1, id2, currency, lang); 
    }
 };

 async loadRecommendations(id1, id2, currency, lang) {
      let that = this;
        try {
          const [r1, r2] = await Promise.all([
            fetch("https://mercstoreules.com/recommendations/products.json?product_id="+id1+"&limit=2&intent=related").then(r => r.json()),
            fetch("https://mercstoreules.com/recommendations/products.json?product_id="+id2+"&limit=2&intent=related").then(r => r.json())
          ]);
          const merged = that.interleave(r1.products, r2.products);

          merged.forEach(function(product){
                that.innerHTML += that.renderSuggestedProduct(product, true, currency, lang);

            })

        } catch (error) {
          console.error("❌ Error cargando recomendaciones:", error);
        }
      }

 uniqueById(arr) {
  return arr.filter((p, i, self) =>
    i === self.findIndex(x => x.id === p.id)
  );
}
 interleave(arr1, arr2) {
    const max = Math.max(arr1.length, arr2.length);
    const result = [];

    for (let i = 0; i < max; i++) {
      if (arr1[i]) result.push(arr1[i]);
      if (arr2[i]) result.push(arr2[i]);
      if (result.length >= 2) break;
    }

    return this.uniqueById(result);
  }
renderSuggestedProduct(product, settings = { favourites_enabled: true }, currency = 'EUR', lang = 'es') {
  var that = this;
  const hasImage = product.images && product.images[0];
  const hasImage2 = product.images && product.images[1];

  const productTitle = (product.title || "").substring(0, 20);
  const firstVariant = product.first_available_variant || product.variants?.[0];
  const multipleVariants = product.variants?.length > 1;
  const addtocartText = (lang =='es')?'Añadir':((lang=='fr')? 'Ajouter':'Add');
  const showProduct = (lang =='es')?'Mostrar producto':((lang=='fr')? 'Afficher le produit':'Show product');

  return `
<div id="suggested-${product.id}" class="suggested__item">
    
      <div class="grid__image__container">
		  ${settings.favourites_enabled &&
                      product.options_with_values?.[0]?.name !== "Importe" &&
                      !product.tags?.includes("rifa")
                      ? `
        <div class="grid__item__favourite added">
          <button class="favourite favourite--button" data-value="${product.handle}" onclick="addToWishlist(this)" data-value="${product.id}">
            <svg class="icon icon--favourites-card" aria-hidden="true" focusable="false" viewBox="0 0 16 16">
              <path d="M11.4,3c0.7,0,1.4,0.3,1.9,0.8c1.1,1.1,1.1,2.8,0,3.9l-0.8,0.8L8,13L3.5,8.5L2.7,7.7c-1.1-1.1-1.1-2.8,0-3.9 C3.2,3.3,3.9,3,4.6,3S6,3.3,6.6,3.8l0.8,0.8L8,5.3l0.6-0.6l0.8-0.8C10,3.3,10.7,3,11.4,3"></path>
            </svg>
          </button>
        </div>`
                      : ""
                    }
        
       ${hasImage ? `
      <a href="${product.url}" class="grid__image__link" tabindex="-1" aria-hidden="true">
          <div class="grid__item__image">
              <div class="image__switch tt--ab">
                  <img
                      class="switch__image--1 fit--cover"
                      src="${product.images[0]}&width=300"
                      alt="${product.title || ""}"
                      loading="lazy"
                  >
                  ${hasImage2 ? `
                  <img
                      class="switch__image--2 fit--cover"
                      src="${product.images[1]}&width=300"
                      alt="${product.title || ""}"
                  >` : ""}
              </div>
          </div>

          <noscript>
              <img class="grid__item__image" src="${product.images[0]}&width=300" alt="${product.title || ""}">
          </noscript>
      </a>
  ` : ""}  
        
      </div>
      <div class="grid__item__text">
        <a class="grid__text__link" href="${product.url}">
          <h3
            class="grid__item__title"
            aria-hidden="true"
            data-langes=""
            data-langen=""
            data-langfr=""
          >${productTitle}</h3>
          <!-- snippet/product-price.liquid -->
        </a>
        <div class="suggested-price">
			${that.renderProductPrice(product, currency, lang)}
		</div>
      </div>
      <a class="view--product button button--primary hidden" href="${product.url}">
        <span></span>
      </a>
        ${multipleVariants ? `
                    <a href="${product.url}" class="view-suggested button button--primary">
                        ${showProduct}
                    </a>
                ` : `
      <wish-add>
        <div class="wishadd__error" hidden></div>
        <div class="button button--primary button--fast-wishlist" data-id=${product.variants[0].id}>
          <span>${addtocartText}</span>
          <div class="loading__spinner hidden">
              <svg
                aria-hidden="true"
                focusable="false"
                class="spinner"
                viewBox="0 0 66 66"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
              </svg>
            </div>
        </div>
      </wish-add>
       `}   
</div>
`;
}
  
renderProductPrice(product, currency , lang) {
  const price = product.price;                      
  const compareAt = product.compare_at_price;       
  const available = product.available !== false;     
  
  const isOnSale = compareAt > price;
  const soldClass = !available ? "sold_out" : "";

  // helpers
  const money = (value) => {
  const num = (value / 100);
  return Number.isInteger(num) ? num.toString() : num.toFixed(2);
  };
  const before = lang === "en" ? currency : "";
  const after  = lang !== "en" ? currency : "";

  return `
<div class="price${isOnSale ? " price--on-sale" : ""}" data-price>
  
  <div class="price__regular">
    <span class="visually--hidden visually--hidden--inline">price</span>

    <span class="price-item price-item--regular ${soldClass}" data-regular-price>
        ${before} ${money(price)} ${after}
    </span>
  </div>

  <div class="price__sale">
    <span class="visually--hidden visually--hidden--inline">sale-price</span>

    <span class="price-item price-item--sale" data-sale-price>
      ${before} ${money(compareAt)} ${after}
    </span>

    <input type="hidden" name="salePrice" value="${price}" class="salePrice">
    <input type="hidden" name="cPrice" value="${compareAt}" class="cPrice">
  </div>

</div>
`;
}


}


//customElements.define('cart-recommendations', CartRecommendations);

function renderProductCard(product) {
    console.log(product);
  // --- ESTADOS PRINCIPALES ---
  let soldOutClass = '';
  if (product.available) {
    if (product.tags.includes('preorder')) soldOutClass = 'grid__item--preorder';
    else if (product.tags.includes('limited')) soldOutClass = 'grid__item--limited';
    else soldOutClass = 'grid__item--normal';
  } else {
    soldOutClass = product.tags.includes('soon')
      ? 'grid__item--soon'
      : 'grid__item--sold-out';
  }

  const halloweenClass = product.tags.includes('halloween') ? 'grid__item--halloween' : '';
  const newinClass = product.tags.includes('newin') ? 'grid__item--newin' : '';
  const liClass = product.images?.[1] ? 'switch__image--1' : 'single--img';
  const featuredImage = product.images?.[0] || '';
  const secondImage = product.images?.[1] || '';
  const title = product.title;
  const url = product.url;

  // --- FAST ADD (adaptación del snippet) ---
  const fastAdd = `
    <fast-add>
      <fieldset class="fast__add__container">
          <div class="fast__add__mobile mobile--fast">
            <svg class="{{ icon_class }}" role="presentation" viewBox="0 0 22 22">
                <polygon points="16,10.5 11.5,10.5 11.5,6 10.5,6 10.5,10.5 6,10.5 6,11.5 10.5,11.5 10.5,16 11.5,16 11.5,11.5 16,11.5 "/>
            </svg>
           </div>
        <div class="product__size__select ${product.variants.length === 1 ? 't-unica' : ''}" data-id="${product.id}" ${product.variants.length === 1 ? 'style="display:none"' : ''}>
          ${product.variants
            .map(
              (variant) => `
              <div data-value="${variant.title}" class="product__size">
                <input
                  id="option-${variant.id}"
                  class="swatch__input"
                  type="radio"
                  name="size-${product.id}"
                  value="${variant.id}"
                  ${product.variants.length === 1 ? 'checked' : ''}
                  ${!variant.available ? 'disabled' : ''}
                >
                <label class="size__number" for="option-${variant.id}">
                  ${variant.option2 || variant.title}
                </label>
              </div>
            `
            )
            .join('')}
        </div>

        <div class="button button--primary button--fast ${
          product.available ? '' : 'disabled'
        }">
          <span>
            ${
              !product.available
                ? product.tags.includes('soon')
                  ? 'Próximamente'
                  : 'Agotado'
                : product.variants.length > 1
                ? 'Seleccionar talla'
                : 'Añadir al carrito'
            }
          </span>
          <div class="loading-spinner"></div>
        </div>
      </fieldset>
    </fast-add>
  `;

  // --- PRICE (adaptación del snippet) ---
  const variant = product.variants[0] || {};
  const compareAt = variant.compare_at_price || variant.price;
  const price = variant.price || 0;
  const onSale = compareAt > price;

   const priceHTML = `
    <div class="price ${onSale ? 'price--on-sale' : ''}" data-price>
      <div class="price__regular">
        <span class="price-item price-item--regular ${variant.available === false ? 'sold_out' : ''}" data-regular-price>
          ${onSale ? formatMoney(compareAt) : formatMoney(price)}
        </span>
      </div>
      ${onSale ? `
        <div class="price__sale">
          <span class="price-item price-item--sale" data-sale-price>
            ${formatMoney(price)}
          </span>
          <input type="hidden" name="salePrice" value="${price}" class="salePrice">
          <input type="hidden" name="cPrice" value="${compareAt}" class="cPrice">
        </div>` : ``}
    </div>
  `;

  // --- PLANTILLA PRINCIPAL ---
  return `
  <div class="grid__item__inner ${soldOutClass} ${halloweenClass} ${newinClass}" data-t="product-card-grid">
    <div class="grid__image__container">
      <div class="grid__item__favourite">
        <button class="favourite favourite--button" data-value="${product.handle}" onclick="addToWishlist(this)" data-id="${product.id}">
          <svg class="icon icon--heart" viewBox="0 0 24 24"><path d="M12 21s-8-5.33-8-10a5 5 0 0 1 10 0 5 5 0 0 1 10 0c0 4.67-8 10-8 10z"/></svg>
        </button>
      </div>

      ${fastAdd}

      <a class="grid__image__link" href="${url}">
        <div class="grid__item__image">
          <div class="sold-out badge">Out of stock</div>
          <div class="preorder badge">Preorder</div>
          <div class="halloween badge">🎃</div>
          <div class="limited badge">Limited</div>
          <div class="soon badge">Soon</div>
          <div class="no-size badge">Unavailable</div>
          <div class="newin badge">Newin</div>
          <div class="image__switch tt--ab">
            <img class="${liClass} fit--cover" src="${featuredImage}" alt="${title}">
            ${
              secondImage
                ? `<img class="switch__image--2 fit--cover" src="${secondImage}" alt="${title}">`
                : ''
            }
          </div>
        </div>
      </a>
    </div>

    <div class="grid__item__text">
      <a class="grid__text__link" href="${url}">
        <h3 class="grid__item__title">${title}</h3>
      </a>
      ${priceHTML}
    </div>
  </div>
  `;
}


// ---------- MONEY FORMATTER (reemplaza Shopify.formatMoney) ----------
function getShopLocale() {
  return document.documentElement.lang || (window.Shopify && window.Shopify.locale) || 'es-ES';
}
function getShopCurrency() {
  // Dawn: Shopify.currency.active; otros temas: Shopify.currency
  return (window.Shopify && (window.Shopify.currency?.active || window.Shopify.currency)) || 'EUR';
}
function formatMoney(cents, { currency, locale } = {}) {
  if (cents == null || isNaN(Number(cents))) return '';
  const cur = currency || getShopCurrency();
  const loc = locale || getShopLocale();
  const amount = Number(cents) / 100;
  return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(amount);
}


function ArrowDisabler(Glide, Components) {
  return {
    mount() {
      // Only in effect when rewinding is disabled
      if (Glide.settings.rewind) {
        return;
      }

      Glide.on(['mount.after', 'run'], () => {
        // Filter out arrows_control

        let par = Components.Html._r.closest('.product__slider--related')||Components.Html._r.closest('.product__slider--recently');

        // Set left arrow state
        var left = par.querySelector('.arrow__left');
        if (left) {
          if (Glide.index === 0) {
            left.setAttribute('disabled', ''); // Disable on first slide
          } else {
            left.removeAttribute('disabled'); // Enable on other slides
          }
        }

        // Set right arrow state
        var right = par.querySelector('.arrow__right');
        if (right) {
          // Glide.index is based on the active slide
          // For bound: true, there will be no empty space & the last slide will never become active
          // Hence add perView to correctly calculate the last slide
          const lastSlideIndex = Glide.settings.bound ? Glide.index + (Glide.settings.perView - 1) : Glide.index;

          if (lastSlideIndex === Components.Sizes.length - 1) {
            right.setAttribute('disabled', ''); // Disable on last slide
          } else {
            right.removeAttribute('disabled'); // Disable on other slides
          }
        }
      });
    },
  };
}

function touchdevice(){
	var isTouchDevice = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0))

	if (isTouchDevice) {
			return true;
		} else {
			return false;
		}	
}

function isMobileBrowse(){
	const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];
    
    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}

function isMobile(){
	if(isMobileBrowse() && touchdevice()){
		return true;
	}else{
		return false;
	}
}

function iniciarCuentaAtras() {
  
  const countdownElement = document.querySelector(".countdown__time");
  const ctimeElement = document.querySelector(".ctime");

  if (!countdownElement || !ctimeElement) return;

  const targetTime = new Date(countdownElement.getAttribute("data-time")).getTime();

  function actualizarCuentaAtras() {
    const ahora = new Date().getTime();
    const diferencia = targetTime - ahora;

    if (diferencia <= 0) {
      ctimeElement.textContent = "¡Tiempo terminado!";
      clearInterval(intervalo);
      return;
    }
    var langString = {
    "es": {
        "days": "Días",
        "hours": "Horas",
        "minutes": "Min",
        "seconds": "Seg"
    },
    "en": {
        "days": "Days",
        "hours": "Hours",
        "minutes": "Min",
        "seconds": "Sec"
    },
    "fr": {
        "days": "Jours",
        "hours": "Heures",
        "minutes": "Min",
        "seconds": "Sec"
    }
    };
    
    var lang = document.querySelector('html').getAttribute('lang');

    const dias = formatearNumero(Math.floor(diferencia / (1000 * 60 * 60 * 24)));
    const horas = formatearNumero(Math.floor((diferencia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
    const minutos = formatearNumero(Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60)));
    const segundos = formatearNumero(Math.floor((diferencia % (1000 * 60)) / 1000));
    ctimeElement.innerHTML = `<div class="time__day"><div class="time__day--result time--result">${dias}</div><div class="time__day--label time--label">${langString[lang].days}</div></div><div class="time--separator">:</div><div class="time__hour"><div class="time__hour--result time--result">${horas}</div><div class="time__hour--label time--label">${langString[lang].hours}</div></div><div class="time--separator">:</div><div class="time__minute"><div class="time__minute--result time--result">${minutos}</div><div class="time__minute--label time--label">${langString[lang].minutes}</div></div><div class="time--separator">:</div><div class="time__second"><div class="time__second--result time--result">${segundos}</div><div class="time__second--label time--label">${langString[lang].seconds}</div></div>`;
  }
  actualizarCuentaAtras();
  const intervalo = setInterval(actualizarCuentaAtras, 1000);
}

function formatearNumero(num) {
  if (num === 0) {
	return "00";
  } else if (num < 10) {
	return "0" + num;
  } else {
	return String(num);
  }
}

function getRecentlyViewedProducts() {
  var viewedProducts = [];
  var cookie = getCookie('recently_viewed_products');
  if (cookie) {
    viewedProducts = JSON.parse(cookie);
  }
  return viewedProducts;
}

function addRecentlyViewedProduct(productId) {
  var viewedProducts = getRecentlyViewedProducts();
  var index = viewedProducts.indexOf(productId);
  if (index > -1) {
    viewedProducts.splice(index, 1);
  }
  viewedProducts.unshift(productId);
  setCookie('recently_viewed_products', JSON.stringify(viewedProducts),  30);
}

/*****************suggested add to cart **************/
function addTocartSuggested(){
  console.log('suggested')
  if(document.querySelector('.add-to-card-suggested') != null){
  document.querySelectorAll('.add-to-card-suggested').forEach(function(e){
    e.addEventListener('click', function(){
      console.log('suggested-click')
      var id = e.getAttribute('data-variant-id');
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (id) {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData();
        e.querySelector('.loading__spinner').classList.remove('hidden');

        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }

        formData.append('quantity', 1);
        formData.append('id', id);

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              return;
            } else if (!cart) {
              // window.location = window.routes.cart_url;
              return;
            }
            const html = new DOMParser().parseFromString(response.sections["cart-drawer"], 'text/html');
            const selectors = ['.cart__drawer'];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
                console.log(targetElement)
                console.log(sourceElement)
            }
          
            
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            let that = this;
            setTimeout(function () {
              that.querySelector('.loading__spinner').classList.add('hidden');
            }, 200);
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

          });
      }
    })
  })
}
}